import { render, staticRenderFns } from "./pushAddPage.vue?vue&type=template&id=06548db8&scoped=true&"
import script from "./pushAddPage.vue?vue&type=script&lang=js&"
export * from "./pushAddPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06548db8",
  null
  
)

export default component.exports